import { render, staticRenderFns } from "./NumEditor.vue?vue&type=template&id=db60e254&"
import script from "./NumEditor.vue?vue&type=script&lang=ts&"
export * from "./NumEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports